// @ts-ignore
import Variables from '@/styles/variables.scss'
import variables from '@finx/web-repository/src/services/Env'

export default {
  error: Variables.clError,
  primary: Variables.clPrimary,
  secondary: Variables.clSecondary,
  tertiary: Variables.clTertiary,
  red: Variables.clRed,
  money: Variables.clMoney,
  background: Variables.clBackground,
  border: Variables.clBorder,
  grayChip: Variables.clGrayChip,
}
